import { mediaQuery } from 'oolib';
import styled from 'styled-components';

export const StyledDataModuleContainer = styled.div`
  ${mediaQuery('md')}{
    display: grid;
    grid-gap: 2rem;
    grid-template-columns: ${({displayAnalytics})=> displayAnalytics? '1fr 300px': '1fr'}
  }
`;